// extracted by mini-css-extract-plugin
export default {"options":"Options_options__jDBWM","cajitas":"Options_cajitas__c7exY","separation":"Options_separation__qZ0-m"};